import { ICellRendererParams } from '@ag-grid-community/core';
import BtnTrashRenderer from './BtnTrashRenderer';

const WorkRecordsTrashRenderer = (props: ICellRendererParams) => {
  return (
    <>
        {props.node.data.is_add && (<BtnTrashRenderer {...props} />)}
    </>
  );
};

export default WorkRecordsTrashRenderer;
